module.exports = __webpack_public_path__ + "img/rexel_logo_mini.7cfc61b5.jpg";